import React from 'react';
import FormikPropsWrapper from '../props-wrapper';
import FormikErrorWrapper from '../error-wrapper';
import TextArea, { TTextArea } from 'components/input/textarea';
import { TFormikInputLabel } from '../types';

const FormikTextArea: React.FC<
    { name: string; rows: number; cols: number } & React.HTMLProps<
        HTMLTextAreaElement
    > &
        TFormikInputLabel &
        TTextArea
> = ({ name, rows, cols, ...textAreaProps }) => {
    return (
        <FormikPropsWrapper<HTMLTextAreaElement> name={name} {...textAreaProps}>
            <FormikErrorWrapper<HTMLTextAreaElement>>
                <TextArea rows={rows} cols={cols} name={name} />
            </FormikErrorWrapper>
        </FormikPropsWrapper>
    );
};

/*const FormikPropsWrapperChild = ({
    meta,
    name,
    ...rest
}: TFormikPropsWrapperChildProps<HTMLTextAreaElement>) => (
    <FormikErrorWrapper<HTMLTextAreaElement> meta={meta}>
        <FormikErrorWrapperChild name={name} {...rest} />
    </FormikErrorWrapper>
);

const FormikErrorWrapperChild = ({
    myRef,
    ...rest
}: TFormikErrorWrapperChildProps<HTMLTextAreaElement>) => (
    <TextArea myRef={myRef} rows={10} cols={10} {...rest} />
);*/

export default FormikTextArea;
